import React from "react";

import { TenantContextType } from "./types";

export const TenantContext = React.createContext<TenantContextType>({
  tenant: null,
  setTenant: () => {},
});
